import { FC } from 'react';

import { rem, Skeleton, Stack } from '@bonusly/design-system';

import { MessageSkeleton } from '../feedback-list/message-skeleton';

export const FeedbackSkeleton: FC = () => {
	return (
		<Stack spacing={4} p={3}>
			<Skeleton h={rem(48)} w="full" />

			<MessageSkeleton />
			<MessageSkeleton />
		</Stack>
	);
};
